import template from './modalDetailLoan.html';
import controller from './modalDetailLoan.controller';
import './modalDetailLoan.scss';

let modalDetailLoanComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
  },
  template,
  controller,
};

export default modalDetailLoanComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/modalDetailLoan/modalDetailLoan.component.js